import { Component, ViewChild, Input, SimpleChanges, Output, EventEmitter, OnChanges } from '@angular/core';

// 3rd Party imports
import { DxPopupComponent } from 'devextreme-angular';

// Service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { WorkflowSharedService } from '../../_services/workflow-shared.service';

// Model imports
import { WorkFlowParametersDto } from '../../_models/workflow-parameters-dto';
import { WorkflowNotesResultDto } from '../../_models/workflow-notes-result-dto';

@Component({
    selector: 'app-workflow-notes-viewer',
    templateUrl: './workflow-notes-viewer.component.html',
    styleUrls: ['./workflow-notes-viewer.component.scss']
})
export class WorkflowNotesViewerComponent implements OnChanges {
    @ViewChild('historyNotesPopup', { static: false }) historyNotesPopup: DxPopupComponent;

    @Input() workflowId: number;
    @Input() communityId: number;
    @Input() visible: boolean;

    @Output() closeNotesPopUp = new EventEmitter<any>();

    previousNotes: string;

    constructor(
        private readonly workflowSharedService: WorkflowSharedService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.workflowId && changes.workflowId.currentValue) {
            this.workflowId = changes.workflowId.currentValue;
            this.getWorkflowNotes();
        }
    }

    onHistoryNotesPopClose(): void {
        this.historyNotesPopup.visible = false;
        this.resetFields();
        this.closeNotesPopUp.emit(true);
    }

    private resetFields(): void {
        this.previousNotes = null;
    }

    private getWorkflowNotes(): void {
        const baseParams: WorkFlowParametersDto = new WorkFlowParametersDto();
        baseParams.workflowId = this.workflowId;
        baseParams.communityId = this.communityId;

        this.workflowSharedService.getWorkflowReadOnlyNotes(baseParams).subscribe(
            (result: WorkflowNotesResultDto) => {
                this.previousNotes = result.note;
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }
}
